import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloClient, InMemoryCache, ApolloProvider, split, HttpLink } from "@apollo/client";
import { getMainDefinition } from '@apollo/client/utilities';
import 'bootstrap/dist/css/bootstrap.css';
import { Auth0Provider } from '@auth0/auth0-react';
import 'bootstrap/dist/css/bootstrap.min.css';



const  uri = 'https://fruve-38fc32d75895.herokuapp.com/api'

// Dividir enlaces si en el futuro se desea usar WebSocket para suscripciones


// Crear instancia de Apollo Client
const client = new ApolloClient({
  uri,
  cache: new InMemoryCache(),
});

// Configurar Auth0Provider
const domain = "dev-qa5dahha.us.auth0.com";
const clientId = "4fXPWHSG87Eaaqag80yzUOSwPWMhRuTY";

ReactDOM.render(


















  
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
    <ApolloProvider client={client}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ApolloProvider>
  </Auth0Provider>,
  document.getElementById('root')
);

reportWebVitals();
